$wj([35],{

/***/ 1879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var appendDiagnosticReportToMessage_1 = __webpack_require__(3984);
exports.appendDiagnosticReportToMessage = appendDiagnosticReportToMessage_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 3984:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var generateDiagnosticReport_1 = __webpack_require__(3985);
function appendDiagnosticReportToMessage(message) {
    return (
    // This indenting is done to preserve the formatting of the string without having to concatenate a new string on each line
    message + "\n<pre>\n================================\n" + generateDiagnosticReport_1.default() + "\n</pre>");
}
exports.default = appendDiagnosticReportToMessage;
//# sourceMappingURL=appendDiagnosticReportToMessage.js.map

/***/ }),

/***/ 3985:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getScriptBaseUrl_1 = __webpack_require__(721);
var LazyAnalytics_1 = __webpack_require__(166);
function generateDiagnosticReport() {
    return (
    // This indenting is done to preserve the formatting of the string without having to concatenate a new string on each line
    "UserAgent: " + window.navigator.userAgent + "\nScript source: " + getScriptBaseUrl_1.default() + "\nSession Id: " + LazyAnalytics_1.getSessionId() + "\nClient ID: " + window.bootstrapDiagnostics.clientId + "\nClient Server: " + window.bootstrapDiagnostics.server + "\nBE Server: " + (window.genericDiagnostics && window.genericDiagnostics.be));
}
exports.default = generateDiagnosticReport;
//# sourceMappingURL=generateDiagnosticReport.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.DiagnosticReport.js